import Image from 'next/image';
import React from 'react';

import booKnowcalendar from '@/assets/images/bookNowcalendar.svg';
import buyBackGuarantee from '@/assets/images/buyBackGuarantee.svg';
import competitiveExchangeRates from '@/assets/images/competitiveExchangeRates.svg';
import fullTimetransferGuarante from '@/assets/images/fullTimetransferGuarante.svg';
import hassleFreeDocs from '@/assets/images/hassleFreeDocs.svg';
import hassleFreeProcess from '@/assets/images/hassleFreeProcess.svg';
import lockInRate from '@/assets/images/lockInRate.svg';
import multiCurrencyAccept from '@/assets/images/multiCurrencyAccept.svg';
import secureShield from '@/assets/images/secureShield.svg';
import withDrawCash from '@/assets/images/withDrawCash.svg';
import worldwideAcceptance from '@/assets/images/worldwideAcceptance.svg';
import routes from '@/utils/constants/forex/routes.json';

const ReasonsUseForex = () => {
  return (
    <section className="home__tab">
      <ul className="new-tabs nav nav-tabs">
        <li className="nav-item bg--light">
          <a
            className="nav-link nav-new-link active"
            data-toggle="tab"
            href="#buyForex"
            id="forex_reason-buy"
          >
            <p className="fx-gray-color text--bold title fx-new-title text-center">
              Buy Forex
            </p>
            <p className="fx-gray-color text--regular desc text-center">
              Multi-currency card or cash at your convenience
            </p>
          </a>
        </li>
        <li className="nav-item bg--light">
          <a
            className="nav-link nav-new-link"
            data-toggle="tab"
            href="#sellForex"
            id="forex_reason-sell"
          >
            <p className="fx-gray-color text--bold title fx-new-title text-center">
              Sell Forex
            </p>
            <p className="fx-gray-color text--regular desc text-center">
              Competitive exchange rates with minimum efforts
            </p>
          </a>
        </li>
        <li className="nav-item bg--light">
          <a
            className="nav-link nav-new-link"
            data-toggle="tab"
            href="#reloadForex"
            id="forex_reason-reload"
          >
            <p className="fx-gray-color text--bold title fx-new-title text-center">
              Reload Forex Card
            </p>
            <p className="fx-gray-color text--regular desc text-center">
              Top-up your Forex card anytime, anywhere
            </p>
          </a>
        </li>
        <li className="nav-item bg--light">
          <a
            className="nav-link nav-new-link"
            data-toggle="tab"
            href="#sendMoney"
            id="forex_reason_send-money"
          >
            <p className="fx-gray-color text--bold title fx-new-title text-center">
              Send Money Abroad
            </p>
            <p className="fx-gray-color text--regular desc text-center">
              Hassle-free international money transfers
            </p>
          </a>
        </li>
      </ul>
      <div className="tab-content bg bg--light">
        <div className="tab-pane active container" id="buyForex">
          <div className="row">
            <div className="col-md-6 col-xl-7">
              <div className="tab__content fx-tab-content">
                <h2 className="text--bold tab__title fx-black-color">
                  Reasons to Buy Forex from Us
                </h2>
                <p className="text--regular tab__desc fx-black-color">
                  Get cash at branch and multi-currency card at home
                </p>
                <div className="align-items-center tab__button web-view">
                  <a
                    href={routes['buy-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__button custom__button--dark fx-book-height"
                    id="forex_buy-book-now"
                  >
                    Book Now
                  </a>
                  <a
                    href={routes['buy-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__link custom__link--dark"
                    id="forex_buy-know-more"
                  >
                    Know more
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-5">
              <div className="tab__card__container">
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="30 minutes door step service"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={competitiveExchangeRates}
                      alt="lowest interest rate"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Competitive</span> exchange
                      rates
                    </p>
                  </div>
                </div>
              </div>
              <div className="tab__card__container">
                <div className="item mb-md-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={lockInRate}
                      alt="lowest interest rate"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Lock-in</span> your exchange
                      rate
                    </p>
                  </div>
                </div>
                <div className="item mb-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={buyBackGuarantee}
                      alt="gold rate"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Buy-back</span> <br />{' '}
                      guarantee
                    </p>
                  </div>
                </div>
              </div>
              <div className="align-items-center tab__button mobile-view">
                <a
                  href={routes['buy-forex']}
                  target='"_self'
                  rel="noopener noreferrer"
                  className="custom__button custom__button--dark fx-book-height"
                  id="forex_mbl-buy-book"
                >
                  Book Now
                </a>
                <a
                  href={routes['buy-forex']}
                  target='"_self'
                  rel="noopener noreferrer"
                  className="custom__link custom__link--dark"
                  id="forex_mbl-buy-learn"
                >
                  Learn more
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane fade container" id="sellForex">
          <div className="row">
            <div className="col-md-6 col-xl-7">
              <div className="tab__content fx-tab-content">
                <h2 className="text--bold tab__title fx-black-color">
                  Reasons to Sell Forex to Us
                </h2>
                <p className="text--regular tab__desc fx-black-color">
                  Get instant money at competitive exchange rates
                </p>
                <div className="align-items-center tab__button web-view">
                  <a
                    href={routes['sell-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__button custom__button--dark fx-book-height"
                    id="forex_reason-sell-book"
                  >
                    Book Now
                  </a>
                  <a
                    href={routes['sell-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__link custom__link--dark"
                    id="forex_reason_sell-know"
                  >
                    Know more
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-5">
              <div className="tab__card__container">
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="buy eSwarna digital gold as low as 1"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={competitiveExchangeRates}
                      alt="Automate your savings with SIP"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Competitive</span> exchange
                      rates
                    </p>
                  </div>
                </div>
              </div>
              <div className="tab__card__container">
                <div className="item mb-md-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={multiCurrencyAccept}
                      alt="Convert to coin and jewellery"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Multi-currency</span>{' '}
                      acceptable
                    </p>
                  </div>
                </div>
                <div className="item mb-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={hassleFreeDocs}
                      alt="Sell instantly"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Hassle-free</span>{' '}
                      documentation
                    </p>
                  </div>
                </div>
              </div>
              <div className="align-items-center tab__button mobile-view">
                <a
                  href={routes['sell-forex']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__button custom__button--dark fx-book-height"
                  id="forex_mbl-sell-book"
                >
                  Book Now
                </a>
                <a
                  href={routes['sell-forex']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__link custom__link--dark"
                  id="forex_mbl-sell-know"
                >
                  Know more
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane fade container" id="reloadForex">
          <div className="row">
            <div className="col-md-6 col-xl-7">
              <div className="tab__content fx-tab-content">
                <h2 className="text--bold tab__title fx-black-color">
                  Reasons to Choose Forex Card with Us
                </h2>
                <p className="text--regular tab__desc fx-black-color">
                  Top-up your Forex card anytime, anywhere
                </p>
                <div className="align-items-center tab__button web-view">
                  <a
                    href={routes['reload-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__button custom__button--dark fx-book-height"
                    id="forex_reason-reload-book"
                  >
                    Book Now
                  </a>
                  <a
                    href={routes['reload-forex']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__link custom__link--dark"
                    id="forex_reason_reload-know"
                  >
                    Know more
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-5">
              <div className="tab__card__container">
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="buy eSwarna digital gold as low as 1"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">100%</span> <br /> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={hassleFreeProcess}
                      alt="Automate your savings with SIP"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Hassle-free</span> <br />{' '}
                      process
                    </p>
                  </div>
                </div>
              </div>
              <div className="tab__card__container">
                <div className="item mb-md-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={worldwideAcceptance}
                      alt="Convert to coin and jewellery"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Worldwide</span> acceptance
                    </p>
                  </div>
                </div>
                <div className="item mb-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={withDrawCash}
                      alt="Sell instantly"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Withdraw cash</span> anytime,
                      anywhere
                    </p>
                  </div>
                </div>
              </div>
              <div className="align-items-center tab__button mobile-view">
                <a
                  href={routes['reload-forex']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__button custom__button--dark fx-book-height"
                  id="forex_mbl-eload-book"
                >
                  Book Now
                </a>
                <a
                  href={routes['reload-forex']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__link custom__link--dark"
                  id="forex_mbl-reload-know"
                >
                  Know more
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane fade container" id="sendMoney">
          <div className="row">
            <div className="col-md-6 col-xl-7">
              <div className="tab__content fx-tab-content">
                <h2 className="text--bold tab__title fx-black-color">
                  Reasons to Send Money Abroad With Us
                </h2>
                <p className="text--regular tab__desc fx-black-color">
                  Transfer money internationally to family, friends or
                  institutions.
                </p>
                <div className="align-items-center tab__button web-view">
                  <a
                    href={routes['outward-remittance']}
                    target="_self"
                    rel="noopener noreferrer"
                    className="custom__button custom__button--dark fx-book-height"
                    id="forex_reasons_send-money-book"
                  >
                    Book Now
                  </a>
                  <a
                    href={routes['outward-remittance']}
                    className="custom__link custom__link--dark"
                    id="forex_reasons_send-money-know"
                  >
                    Know more
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-5">
              <div className="tab__card__container">
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={fullTimetransferGuarante}
                      alt="buy eSwarna digital gold as low as 1"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">24 hour*</span> transfers
                      guaranteed
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={competitiveExchangeRates}
                      alt="Automate your savings with SIP"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">Competitive</span> exchange
                      rates
                    </p>
                  </div>
                </div>
              </div>
              <div className="tab__card__container">
                <div className="item mb-md-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="Convert to coin and jewellery"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item mb-0">
                  <div className="tab__card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={booKnowcalendar}
                      alt="Sell instantly"
                    />
                    <p className="fx-black-color text--regular title text-center">
                      Book now,
                      <span className="text--bold">
                        {' '}
                        <br /> pay later
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="align-items-center tab__button mobile-view">
                <a
                  href={routes['outward-remittance']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__button custom__button--dark fx-book-height"
                  id="forex_mbl_send-money_book"
                >
                  Book Now
                </a>
                <a
                  href={routes['outward-remittance']}
                  target="_self"
                  rel="noopener noreferrer"
                  className="custom__link custom__link--dark"
                  id="forex_mbl_send-money_know"
                >
                  Know more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReasonsUseForex;
